<template>
  <el-form ref="tableForm" label-width="0px" :model="tableFormData" :disabled="disabled">
    <div class="text-right mb-10px">
      <el-button
        type="primary"
        @click.stop="$refs.dialog.showDialog = true"
        size="small"
        :disabled="disabled"
        >引用检查项目</el-button
      >
      <el-button type="primary" @click.stop="createRow" size="small" :disabled="disabled"
        >新增</el-button
      >
    </div>
    <el-table max-height="400px" :data="tableData" border class="w-full" stripe>
      <el-table-column label="检查项目" prop="projectName" show-overflow-tooltip width="200">
        <template slot="header">
          <span class="text-red-500">*</span>
          检查项目
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}projectName`"
            :rules="[
              {
                required: true,
                message: '检查项目不能为空',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入检查项目'"
              v-model="tableFormData[`${scope.row.id}projectName`]"
              @change="(value) => tableChange(scope.row, value, 'projectName')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="标准" prop="standard" show-overflow-tooltip width="200">
        <template slot="header">
          <span class="text-red-500">*</span>
          标准
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}standard`"
            :rules="[{ required: true, message: '标准不能为空', trigger: ['blur', 'change'] }]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入标准'"
              v-model="tableFormData[`${scope.row.id}standard`]"
              @change="(value) => tableChange(scope.row, value, 'standard')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="不符合标准情况"
        prop="noComplianceStandard"
        show-overflow-tooltip
        width="200"
      >
        <template slot="header">
          <span class="text-red-500">*</span>
          不符合标准情况
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}noComplianceStandard`"
            :rules="[
              {
                required: true,
                message: '不符合标准情况不能为空',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入不符合标准情况'"
              v-model="tableFormData[`${scope.row.id}noComplianceStandard`]"
              @change="(value) => tableChange(scope.row, value, 'noComplianceStandard')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="主要后果" prop="consequences" show-overflow-tooltip width="200">
        <template slot="header">
          <span class="text-red-500">*</span>
          主要后果
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}consequences`"
            :rules="[
              {
                required: true,
                message: '主要后果不能为空',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入主要后果'"
              v-model="tableFormData[`${scope.row.id}consequences`]"
              @change="(value) => tableChange(scope.row, value, 'consequences')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column label="是否重点管控" prop="isFocusControl" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.isFocusControl"
            size="mini"
            :placeholder="disabled ? '' : '请输入是否重点管控'"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="详情位置" prop="location" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.location"
            maxlength="100"
            show-word-limit
            :placeholder="disabled ? '' : '请输入详情位置'"
          >
          </el-input>
        </template>
      </el-table-column>

      <el-table-column
        label="财产伤亡预测"
        prop="assetsCasualtyPredict"
        show-overflow-tooltip
        min-width="200"
      >
        <template slot-scope="scope">
          <el-input
            maxlength="100"
            show-word-limit
            v-model="scope.row.assetsCasualtyPredict"
            :placeholder="disabled ? '' : '请输入财产伤亡预测'"
          >
          </el-input>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.stop="deleteRow(scope.row.id)"
            :disabled="disabled || tableData.length === 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <SelectCheckItems type="equip" @handleOk="handleOk" :values="selectValues" ref="dialog" />
  </el-form>
</template>

<script>
import { EquipmentFacilitySourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import SelectCheckItems from '../RiskIdentifyListTable/SelectCheckItems'

const equipmentFacilitySourcesDangerIdentifyApi = new EquipmentFacilitySourcesDangerIdentifyApi()
const uuid = require('uuid')

export default {
  model: {
    prop: 'data',
    event: 'change',
  },
  name: 'equip-identify',
  components: {
    SelectCheckItems,
  },
  props: {
    taskId: {
      default: '',
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      tableFormData: {},
      tableData: [],
      accidentTypeList: [],
    }
  },
  computed: {
    selectValues() {
      return this.tableData.map((item) => {
        return item.id
      })
    },
  },
  watch: {
    taskId: {
      immediate: true,
      handler(list) {
        this.getData()
      },
    },
  },
  created() {},
  mounted() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.AccidentType'],
      ['accidentTypeList'],
      this
    )
  },
  methods: {
    handleOk(values) {
      const data = JSON.parse(JSON.stringify(values)).filter((item) => {
        return (
          !this.tableData.length ||
          !this.tableData.find((i) => {
            return i.id === item.id
          })
        )
      })
      data.forEach((item) => {
        this.$set(this.tableFormData, `${item.id}projectName`, item.projectName)
        this.$set(this.tableFormData, `${item.id}standard`, item.standard)
        this.$set(this.tableFormData, `${item.id}noComplianceStandard`, item.noComplianceStandard)
        this.$set(this.tableFormData, `${item.id}consequences`, item.consequences)
      }, {})
      this.tableData = this.tableData.concat(data)
    },
    async getData() {
      if (!this.taskId) return
      const [err, res] = await equipmentFacilitySourcesDangerIdentifyApi.getCheckProjectList(
        this.taskId
      )
      if (!err) {
        if (!res.length && !this.disabled) {
          this.createRow()
          return
        }
        this.tableData = res
        this.tableData.forEach((item) => {
          this.$set(this.tableFormData, `${item.id}projectName`, item.projectName)
          this.$set(this.tableFormData, `${item.id}standard`, item.standard)
          this.$set(this.tableFormData, `${item.id}noComplianceStandard`, item.noComplianceStandard)
          this.$set(this.tableFormData, `${item.id}consequences`, item.consequences)
        }, {})
      }
    },
    tableChange(row, value, filed) {
      row[filed] = value
    },
    validate() {
      let flag
      this.$refs.tableForm.validate((valid) => {
        flag = valid
      })
      return flag
    },
    createRow() {
      this.tableData.push({
        id: uuid(),
      })
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        return item.id !== id
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
